/**
 * アコーディオン共通ヘルパー関数
 */

/**
 * アコーディオンを初期化
 * @param selector - アコーディオン要素のセレクタ
 * @param config - アコーディオンの設定
 */
export function initAccordion(
  selector: string,
  config: {
    headerClass: string;
    viewMoreBtnClass: string;
    toggleBtnClass: string;
    innerClass: string;
    contentClass?: string;
  },
): void {
  const accordions = document.querySelectorAll(selector);

  for (const accordion of Array.from(accordions)) {
    const header = accordion.querySelector(
      `.${config.headerClass}`,
    ) as HTMLElement;
    const viewMoreBtn = accordion.querySelector(
      `.${config.viewMoreBtnClass}`,
    ) as HTMLButtonElement;
    const toggleBtn = accordion.querySelector(
      `.${config.toggleBtnClass}`,
    ) as HTMLButtonElement;
    const inner = accordion.querySelector(
      `.${config.innerClass}`,
    ) as HTMLElement;

    if (!header || !viewMoreBtn || !inner) continue;

    // data-html属性からHTMLを取得して展開（商品仕様の場合）
    if (config.contentClass) {
      const content = accordion.querySelector(
        `[data-${config.contentClass}]`,
      ) as HTMLElement;
      const htmlAttr = `data-${config.contentClass}-html`;
      const htmlContent = accordion.getAttribute(htmlAttr);
      if (content && htmlContent) {
        content.innerHTML = htmlContent;
      }
    }

    // 初期状態で1段階目のアコーディオンを開く
    const isInitiallyOpen = accordion.classList.contains("is-open");
    if (isInitiallyOpen) {
      inner.style.paddingBottom = "24px";
      const contentHeight = inner.scrollHeight;
      inner.style.maxHeight = `${contentHeight}px`;
    }

    // 修正: is-content-expanded 付きは VIEW MORE を開いた状態で初期化する
    if (accordion.classList.contains("is-content-expanded")) {
      const spanElement = viewMoreBtn.querySelector("span");
      if (spanElement) {
        spanElement.textContent = "VIEW LESS";
      }
      viewMoreBtn.setAttribute("aria-expanded", "true");
    }

    // ヘッダークリックでアコーディオンを開閉
    header.addEventListener("click", () => {
      const isOpen = accordion.classList.contains("is-open");

      if (isOpen) {
        // 閉じる
        inner.style.maxHeight = "0";
        inner.style.paddingBottom = "0";
        accordion.classList.remove("is-open");
        if (toggleBtn) {
          toggleBtn.setAttribute("aria-expanded", "false");
        }
      } else {
        // 開く - 実際の高さを計算
        accordion.classList.add("is-open");
        inner.style.paddingBottom = "24px";
        const contentHeight = inner.scrollHeight;
        inner.style.maxHeight = `${contentHeight}px`;
        if (toggleBtn) {
          toggleBtn.setAttribute("aria-expanded", "true");
        }
      }
    });

    // VIEW MOREボタンクリックでコンテンツの高さ制限を解除/追加
    viewMoreBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      const isContentExpanded = accordion.classList.contains(
        "is-content-expanded",
      );

      if (isContentExpanded) {
        // 閉じる（高さ制限を追加）
        accordion.classList.remove("is-content-expanded");
        const spanElement = viewMoreBtn.querySelector("span");
        if (spanElement) {
          spanElement.textContent = "VIEW MORE";
        }
        viewMoreBtn.setAttribute("aria-expanded", "false");
        // 高さを再計算（150pxに制限された状態）
        requestAnimationFrame(() => {
          const contentHeight = inner.scrollHeight;
          inner.style.maxHeight = `${contentHeight}px`;
        });
      } else {
        // 開く（高さ制限を解除）
        accordion.classList.add("is-content-expanded");
        const spanElement = viewMoreBtn.querySelector("span");
        if (spanElement) {
          spanElement.textContent = "VIEW LESS";
        }
        viewMoreBtn.setAttribute("aria-expanded", "true");
        // 高さを再計算（全体が表示された状態）
        requestAnimationFrame(() => {
          const contentHeight = inner.scrollHeight;
          inner.style.maxHeight = `${contentHeight}px`;
        });
      }
    });
  }
}
